import React, { useEffect, useRef } from "react";
import { useKSK2130_R01Store } from "./Store_KSK2130_R01";

interface BarcodeScanBarProps {
    onScan: (code: string) => void;
}

export const Info_KSK2130_R01 = ({ onScan }: BarcodeScanBarProps) => {
    const { selectedKSK2130_R01, KSK2130_R01Filter, setKSK2130_R01Filter } = useKSK2130_R01Store();
    const inputRef = useRef<HTMLInputElement>(null);

    // 1) 작업지시가 선택되면 자동으로 포커스 이동
    useEffect(() => {
        if (selectedKSK2130_R01) {
            inputRef.current?.focus();
        }
    }, [selectedKSK2130_R01]);

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key !== "Enter") return;
        const code = KSK2130_R01Filter.barcodeInput.trim();
        if (code) onScan(code);
        setKSK2130_R01Filter({ barcodeInput: "" });

        // 2) 스캔 처리 직후 다시 포커스 (다음 스캔 대비)
        requestAnimationFrame(() => {
            inputRef.current?.focus();
        });
    };

    return (
        <div className="w-full h-[44px] flex items-center gap-2 px-3 border border-gray-300 bg-white shrink-0">
            <span className="text-base text-black">자재 LOT 바코드</span>
            <input
                ref={inputRef}
                disabled={!selectedKSK2130_R01}
                value={KSK2130_R01Filter.barcodeInput}
                onChange={(e) => setKSK2130_R01Filter({ barcodeInput: e.target.value })}
                onKeyDown={handleKeyDown}
                placeholder={selectedKSK2130_R01 ? "" : "작업지시를 먼저 선택하세요"}
                className="flex-1 h-[30px] border rounded px-2"
            />
        </div>
    );
};